import React, { FC } from 'react';
import { Chip as ChipUDL } from './component';
import { Chip as ChipLegacy } from './component.legacy';
import { ChipProps } from './types';

export const Chip: FC<ChipProps> = props => {
  if (props.renderAsLegacy) {
    return <ChipLegacy {...props} />;
  } else {
    return <ChipUDL {...props} />;
  }
};
